"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Card_1 = __importDefault(require("react-bootstrap/Card"));
var themes_1 = require("../../providers/themes");
var state_enum_1 = __importDefault(require("../../shared/enums/state.enum"));
var status_enum_1 = __importDefault(require("../../shared/enums/status.enum"));
var style_enum_1 = __importDefault(require("../../shared/enums/style.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var deepMerge_1 = __importDefault(require("../../shared/utilities/deepMerge"));
var visual_action_content_1 = __importDefault(require("../visual-action-content"));
var visual_action_defaults_1 = __importDefault(require("./visual-action.defaults"));
require("./visual-action.scss");
/**
 * Renders a visual action component.
 * This is the middle component of the hierarchy of visual action components, which consist of:
 * - VisualActionContainer
 * -- Visual Action
 * --- VisualActionContent
 * @param props - The props for the visual action component.
 * @returns The rendered visual action component.
 */
function VisualAction(props) {
    return (react_1.default.createElement(themes_1.ThemeContext.Consumer, null, function (_a) {
        var _b, _c, _d;
        var theme = _a.theme;
        var defaults = visual_action_defaults_1.default[theme];
        var vaProps = (0, deepMerge_1.default)(defaults, __assign({}, props));
        var complete = vaProps.state === state_enum_1.default.COMPLETE;
        var loading = vaProps.status === status_enum_1.default.LOADING;
        var error = vaProps.status === status_enum_1.default.ERROR;
        var locked = vaProps.state === state_enum_1.default.LOCKED;
        var background = loading || error || vaProps.priority === undefined ? undefined : vaProps.priority;
        var style = vaProps.style || style_enum_1.default.ROUNDED;
        var visualActionClasses = (0, classMap_1.default)("animation", "shape ".concat(style), vaProps.size && (vaProps.size === "1:1" ? "aspect-1-1" : "size ".concat(vaProps.size)), loading ? "pulse loading bg-transparent" : "", error ? "error" : "", locked || loading || error || complete ? "disabled" : "shadow-hover cursor-pointer", vaProps.leftAlign ? "" : "mx-auto", vaProps.className);
        var circle = style === style_enum_1.default.CIRCLE;
        var bodyClasses = (0, classMap_1.default)("card-body visual-action-body container h-100", vaProps.showOverflow ? "" : "overflow-hidden", circle ? "rounded-circle" : "", vaProps.bodyClassName);
        var content = __assign(__assign({}, vaProps.content), { action: ((_b = vaProps.content) === null || _b === void 0 ? void 0 : _b.action) && __assign(__assign({}, vaProps.content.action), { enabled: !(locked || loading || error || complete), className: (0, classMap_1.default)(((_c = vaProps.content.action) === null || _c === void 0 ? void 0 : _c.className) || "", (!vaProps.callback && "stretched-link") || "", (circle && "after-border-radius-circle") || "") }) });
        return (react_1.default.createElement(Card_1.default, { className: (0, classMap_1.default)("mpng-ux-visual-action", visualActionClasses, "background-cover", "background-center", background && "bg-".concat(background)),
            onClick: (_d = vaProps.callback) !== null && _d !== void 0 ? _d : undefined,
            style: vaProps.bgImage
                ? {
                    backgroundImage: "url(".concat(vaProps.bgImage, ")")
                }
                : undefined,
            tabIndex: vaProps.callback ? 0 : undefined },
            react_1.default.createElement(Card_1.default.Body, { className: bodyClasses },
                react_1.default.createElement(visual_action_content_1.default, __assign({}, content)))));
    }));
}
exports.default = VisualAction;
